import axiosClient from "./axios";

export default {
  signup: <V>(data: V) => axiosClient.post(`/signup`, data),
  validateOtp: <V>(data: V) => axiosClient.post(`/otp`, data),
  setPassword: <V>(data: V) => axiosClient.post(`/password`, data),
  signin: <V>(data: V) => axiosClient.post(`/signin`, data),
  forgotPassword: <V>(data: V) => axiosClient.put(`/password`, data),
  fetchSSORedirect: <V>(data: V) => axiosClient.post('/fetch-sso-redirect-by-tenant', data),
  signInViaSSO: <V>(data: V) => axiosClient.post('/signin-via-sso', data),
}
